<template>
  <b-badge
    :variant="getVariant(status)"
    class="font-weight-bold"
  >
    {{ getLabel(status) }}
  </b-badge>
</template>

<script>
import { BBadge } from 'bootstrap-vue'

export default {
  name: 'GapStatusBadge',
  components: {
    BBadge,
  },
  props: {
    status: {
      type: String,
      required: true,
      validator: (value) => ['Implementado', 'Parcial', 'No implementado', 'No aplica'].includes(value),
    },
  },
  setup(props) {
    const getVariant = (status) => {
      const variants = {
        'Implementado': 'success',
        'Parcial': 'warning',
        'No implementado': 'danger',
        'No aplica': 'secondary',
      }
      return variants[status] || 'secondary'
    }

    const getLabel = (status) => {
      return status || 'N/A'
    }

    return {
      getVariant,
      getLabel,
    }
  },
}
</script>

<style scoped>
.badge {
  min-width: 100px;
  padding: 0.5rem 0.75rem;
}
</style>
